module.exports = __webpack_public_path__ + "386184e8f8a1af56df647182d605a150.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/face/makeup-blue-s.png
// module id = 2353
// module chunks = 0